import { createQueryKeys } from '@lukemorales/query-key-factory';

export const presetQueryKeys = createQueryKeys('preset', {
  fetchPreset: (hostname: string) => ['fetchPreset', hostname],
});
